import { render, staticRenderFns } from "./BrandSelect.vue?vue&type=template&id=5105e330&scoped=true&"
import script from "./BrandSelect.vue?vue&type=script&lang=js&"
export * from "./BrandSelect.vue?vue&type=script&lang=js&"
import style0 from "./BrandSelect.vue?vue&type=style&index=0&id=5105e330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5105e330",
  null
  
)

export default component.exports